/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
};

export type AddOnVariant = Variant & {
  __typename?: 'AddOnVariant';
  id: Scalars['Int']['output'];
  macroNutrients: MacroNutrients;
  product: Product;
  tags: Array<Maybe<Tag>>;
};


export type AddOnVariantTagsArgs = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CartBlueprint = {
  __typename?: 'CartBlueprint';
  deliveries: Array<CartDeliveryBlueprint>;
  deliveryWeek: Scalars['Date']['output'];
};

export type CartBlueprintInput = {
  /** Bypass validation of provided deliveryBlueprint and lineItemBlueprints against program deliveries */
  bypassDeliveryBlueprintValidation?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBlueprints: Array<CartDeliveryBlueprintInput>;
  deliveryWeek: Scalars['Date']['input'];
  metroIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  programId: Scalars['Int']['input'];
  storeFrontId?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['Int']['input'];
};

export type CartDeliveryBlueprint = {
  __typename?: 'CartDeliveryBlueprint';
  deliveryDate: Scalars['Date']['output'];
  lineItems: Array<LineItemBlueprint>;
};

export type CartDeliveryBlueprintInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItemBlueprints: Array<LineItemBlueprintInput>;
};

export type Catalog = {
  __typename?: 'Catalog';
  eligibleDeliveryDates: Array<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  items: Array<Maybe<CatalogItem>>;
  metroId: Scalars['Int']['output'];
  /** The unique ID for the Catalog in the source system */
  remoteSourceId: Scalars['String']['output'];
  sellableFrom: Scalars['DateTime']['output'];
  sellableTo: Scalars['DateTime']['output'];
  tenantEligibilityConfigId?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['Int']['output'];
};


export type CatalogItemsArgs = {
  input: CatalogItemsInput;
};

export type CatalogInput = {
  deliveryWeek: Scalars['Date']['input'];
  eligibleDeliveryDates: Array<Scalars['Date']['input']>;
  mealVariantItems: Array<MealVariantCatalogItemInput>;
  metroId: Scalars['Int']['input'];
  /** The unique ID for the Catalog in the source system */
  remoteSourceId: Scalars['String']['input'];
  sellableFrom: Scalars['DateTime']['input'];
  sellableTo: Scalars['DateTime']['input'];
  storeFrontId: Scalars['Int']['input'];
  tenantEligibilityConfigId?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['Int']['input'];
};

export type CatalogItem = {
  __typename?: 'CatalogItem';
  id: Scalars['Int']['output'];
  /** Reflects pricing when users are getting a one-time order */
  oneTimeOrderPriceInCents: Scalars['Int']['output'];
  /** Reflects pricing when users are subscribed */
  priceInCents: Scalars['Int']['output'];
  recommenderScore?: Maybe<Scalars['Float']['output']>;
  soldOut: Scalars['Boolean']['output'];
  variant: Variant;
};

export type CatalogItemsFilter = {
  designers?: InputMaybe<Array<InputMaybe<FilterDesigner>>>;
  ingredientsToAvoid?: InputMaybe<Array<InputMaybe<FilterIngredientToAvoid>>>;
  macroNutrients?: InputMaybe<FilterMacroNutrients>;
  mealVariantSizes?: InputMaybe<Array<InputMaybe<MealSize>>>;
  soldOut?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<FilterTag>>>;
  variantTypes?: InputMaybe<Array<InputMaybe<VariantType>>>;
};

export type CatalogItemsInput = {
  filter: CatalogItemsFilter;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogsFilter = {
  deliveryWeeks?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  eligibleDeliveryDates?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** zipCodes is ignored when this is provided */
  metroIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Ignored when metroIds is provided */
  zipCodes?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
};

export type CatalogsInput = {
  filter: CatalogsFilter;
};

export type CreateCatalogInput = {
  catalog: CatalogInput;
};

export type CreateCatalogPayload = {
  __typename?: 'CreateCatalogPayload';
  /** The created or updated Catalog */
  catalog: Catalog;
};

export type CreateProgramInput = {
  createStripeProduct?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['NonEmptyString']['input'];
  durationInWeeks: Scalars['Int']['input'];
  extraConfig: ExtraConfig;
  metroConfigurations: Array<MetroConfig>;
  priceInCents: Scalars['Int']['input'];
  sellableFrom: Scalars['DateTime']['input'];
  sellableTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Price ID of the associated product in Stripe. Note that in the database this is non nullable, so an empty string will be inserted if this is not provided. */
  stripePriceId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tenantId: Scalars['Int']['input'];
  title: Scalars['NonEmptyString']['input'];
};

export enum Day {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type Designer = {
  __typename?: 'Designer';
  /** Typically, the chef who created the meal (e.g. "Chef John") */
  name: Scalars['String']['output'];
};

export type DesignerInput = {
  /** Typically, the chef who created the meal (e.g. "Chef John") */
  name: Scalars['String']['input'];
};

export type ExtraConfig = {
  heroImg: HeroImgInput;
};

export type FilterDesigner = {
  /** Typically, the chef who created the meal (e.g. "Chef John") */
  name: Scalars['String']['input'];
};

export type FilterIngredientToAvoid = {
  id: Scalars['Int']['input'];
};

export type FilterMacroNutrients = {
  addedSugarInG?: InputMaybe<RangeFilter>;
  calories?: InputMaybe<RangeFilter>;
  cholesterolInMg?: InputMaybe<RangeFilter>;
  dietaryFiberInG?: InputMaybe<RangeFilter>;
  netCarbsInG?: InputMaybe<RangeFilter>;
  proteinInG?: InputMaybe<RangeFilter>;
  saturatedFatInG?: InputMaybe<RangeFilter>;
  servingSizeInOz?: InputMaybe<RangeFilter>;
  sodiumInMg?: InputMaybe<RangeFilter>;
  sugarsInG?: InputMaybe<RangeFilter>;
  totalCarbsInG?: InputMaybe<RangeFilter>;
  totalFatInG?: InputMaybe<RangeFilter>;
};

export type FilterTag = {
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HeroImgInput = {
  lg: Scalars['NonEmptyString']['input'];
  md: Scalars['NonEmptyString']['input'];
  sm: Scalars['NonEmptyString']['input'];
};

/** Ingredients to avoid includes allergens and dietary restrictions */
export type IngredientToAvoid = {
  __typename?: 'IngredientToAvoid';
  category: IngredientToAvoidCategory;
  displayName: Scalars['String']['output'];
  isAllergen: Scalars['Boolean']['output'];
  legacyAllergenItemId: Scalars['Int']['output'];
};

export type IngredientToAvoidCategory = {
  __typename?: 'IngredientToAvoidCategory';
  displayName: Scalars['String']['output'];
  legacyAllergenCategoryId: Scalars['Int']['output'];
};

export type IngredientsToAvoidCategoryInput = {
  displayName: Scalars['String']['input'];
  legacyAllergenCategoryId: Scalars['Int']['input'];
};

export type IngredientsToAvoidInput = {
  category: IngredientsToAvoidCategoryInput;
  displayName: Scalars['String']['input'];
  isAllergen: Scalars['Boolean']['input'];
  legacyAllergenItemId: Scalars['Int']['input'];
};

export type LineItemBlueprint = {
  __typename?: 'LineItemBlueprint';
  quantity: Scalars['Int']['output'];
  variant: Variant;
};

export type LineItemBlueprintInput = {
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type MacroNutrients = {
  __typename?: 'MacroNutrients';
  addedSugarInG?: Maybe<Scalars['Float']['output']>;
  calories: Scalars['Float']['output'];
  /** @deprecated Replaced by "calories" */
  caloriesInG: Scalars['Float']['output'];
  cholesterolInMg: Scalars['Float']['output'];
  dietaryFiberInG: Scalars['Float']['output'];
  netCarbsInG: Scalars['Float']['output'];
  proteinInG: Scalars['Float']['output'];
  saturatedFatInG: Scalars['Float']['output'];
  servingSizeInOz: Scalars['Float']['output'];
  sodiumInMg: Scalars['Float']['output'];
  sugarsInG: Scalars['Float']['output'];
  totalCarbsInG: Scalars['Float']['output'];
  totalFatInG: Scalars['Float']['output'];
};

export enum MealSize {
  Boost = 'BOOST',
  Standard = 'STANDARD'
}

export type MealVariant = Variant & {
  __typename?: 'MealVariant';
  containsAllergensCopy: Scalars['String']['output'];
  gardenMealNutritionalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ingredientsToAvoid: Array<IngredientToAvoid>;
  macroNutrients: MacroNutrients;
  /** Nutrition information for meal extras (e.g sauce) */
  nutritionCaveat?: Maybe<Scalars['String']['output']>;
  product: Product;
  publicIngredientsCopy: Scalars['String']['output'];
  size: MealSize;
  tags: Array<Maybe<Tag>>;
};


export type MealVariantTagsArgs = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MealVariantCatalogItemInput = {
  priceInCents: Scalars['Int']['input'];
  variant: MealVariantInput;
};

export type MealVariantInput = {
  /** Comma-delimited allergens (e.g. "eggs, sesame, tree nuts (coconut)" */
  containsAllergensCopy?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the corresponding rails app's garden_meal_nutritionals
   *       record. This will solely be used for debugging/data tracing. This input
   *       will be deprecated once we move away from using the rails app as our
   *       source of meal data.
   */
  gardenMealNutritionalId: Scalars['Int']['input'];
  ingredientsToAvoid?: InputMaybe<Array<IngredientsToAvoidInput>>;
  /** Nutrition information for meal extras (e.g sauce) */
  nutritionCaveat?: InputMaybe<Scalars['String']['input']>;
  nutritionalProperties: NutritionalPropertiesInput;
  product: ProductInput;
  publicIngredientsCopy: Scalars['String']['input'];
  size: MealSize;
  tags: Array<TagInput>;
};

export type Metro = {
  __typename?: 'Metro';
  id: Scalars['Int']['output'];
  storefront: Storefront;
};

/** Configuration for programMetros and programDeliveries. Note each entry in input array roughly corresponds to a storefront. */
export type MetroConfig = {
  /**
   * Metro IDs for which to create program metros and program deliveries.
   *                      Note: all metroIds must belong to the same tenant store front as this is
   *                      essentially a way to interface with store front configuration in a more precise, scoped way.
   *                      Relatedly, the storeFrontId param will be ignored if this is provided.
   */
  metroIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  programDeliveries: Array<ProgramDeliveryInput>;
  /** Storefront ID for which to create program metros and program deliveries. Note: will be ignored if metroIds is provided. */
  storeFrontId?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** @deprecated Replaced by POST /v1/internal/publish-draft-catalogs */
  createCatalog: CreateCatalogPayload;
  createProgram: Program;
  createProgramCartBlueprints: Program;
};


export type MutationCreateCatalogArgs = {
  input: CreateCatalogInput;
};


export type MutationCreateProgramArgs = {
  input: CreateProgramInput;
};


export type MutationCreateProgramCartBlueprintsArgs = {
  input: CartBlueprintInput;
};

export type NutritionalPropertiesInput = {
  addedSugarInG?: InputMaybe<Scalars['Float']['input']>;
  calories: Scalars['Float']['input'];
  caloriesInG?: InputMaybe<Scalars['Float']['input']>;
  cholesterolInMg: Scalars['Float']['input'];
  dietaryFiberInG: Scalars['Float']['input'];
  netCarbsInG: Scalars['Float']['input'];
  proteinInG: Scalars['Float']['input'];
  saturatedFatInG: Scalars['Float']['input'];
  servingSizeInOz: Scalars['Float']['input'];
  sodiumInMg: Scalars['Float']['input'];
  sugarsInG: Scalars['Float']['input'];
  totalCarbsInG: Scalars['Float']['input'];
  totalFatInG: Scalars['Float']['input'];
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  designer: Designer;
  gardenMealId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  review?: Maybe<Review>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ProductInput = {
  /** Examples: "A_LA_CARTE", "BREAKFAST", "LUNCH_DINNER" */
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  designer: DesignerInput;
  /**
   * The ID of the corresponding rails app's garden_meals record.
   *       eComm needs this ID to create and modify orders and garden_deliveries in
   *       the rails app. This field will be deprecated once we move away from the rails
   *       app and its garden deliveries
   */
  gardenMealId: Scalars['Int']['input'];
  /** rails id coalescing the override_garden_meal_id with the garden_meal_id */
  gardenMealOverrideId?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type Program = {
  __typename?: 'Program';
  crossedOutPriceInCents?: Maybe<Scalars['Int']['output']>;
  deliveryFeePerWeekInCents: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  durationInWeeks: Scalars['Int']['output'];
  extraConfig?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  programMetros: Array<ProgramMetro>;
  sellableFrom: Scalars['DateTime']['output'];
  sellableTo?: Maybe<Scalars['DateTime']['output']>;
  stripePriceId: Scalars['String']['output'];
  tenantId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** Includes delivery fees but not taxes */
  totalPriceInCents: Scalars['Int']['output'];
};


export type ProgramProgramMetrosArgs = {
  metroId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['PostalCode']['input'];
};

export type ProgramDelivery = {
  __typename?: 'ProgramDelivery';
  day: Day;
  variantQuantity: Scalars['Int']['output'];
};

export type ProgramDeliveryInput = {
  day: Day;
  variantQuantity: Scalars['Int']['input'];
};

export type ProgramMetro = {
  __typename?: 'ProgramMetro';
  cartBlueprints: Array<CartBlueprint>;
  deliveries: Array<ProgramDelivery>;
  metro: Metro;
  metroId: Scalars['Int']['output'];
};


export type ProgramMetroCartBlueprintsArgs = {
  deliveryWeek: Scalars['Date']['input'];
  metroId: Scalars['Int']['input'];
};

export type ProgramsFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** zipCodes is ignored when this is provided */
  metroIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Ignored when metroIds is provided */
  zipCodes?: InputMaybe<Array<Scalars['PostalCode']['input']>>;
};

export type ProgramsInput = {
  filter?: InputMaybe<ProgramsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  catalogs: Array<Catalog>;
  ingredientsToAvoid: Array<IngredientToAvoid>;
  programs: Array<Program>;
  tags: Array<TagV2>;
  validateAddressForProgram: Program;
  variants: Array<Variant>;
};


export type QueryCatalogsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  input: CatalogsInput;
};


export type QueryProgramsArgs = {
  input: ProgramsInput;
};


export type QueryTagsArgs = {
  input: TagsInput;
};


export type QueryValidateAddressForProgramArgs = {
  address: ProgramAddressInput;
  programId: Scalars['Int']['input'];
};


export type QueryVariantsArgs = {
  input: VariantsInput;
};

export type RangeFilter = {
  /** Greater than or equal to (inclusive). Absence of this field is interpreted as -Infinity */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Less than (not inclusive). Absence of this field is interpreted as Infinity */
  lt?: InputMaybe<Scalars['Float']['input']>;
};

export type Review = {
  __typename?: 'Review';
  deliveredOn: Scalars['String']['output'];
  /** ternary value of review */
  value: Scalars['Int']['output'];
};

export type Storefront = {
  __typename?: 'Storefront';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Any attribute that should be searchable. */
export type Tag = {
  __typename?: 'Tag';
  category: TagCategory;
  displayName: Scalars['String']['output'];
  /** @deprecated Replaced by "displayName" */
  displayValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** @deprecated Replaced by "id" */
  value: Scalars['String']['output'];
};

export type TagCategory = {
  __typename?: 'TagCategory';
  apiName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Standard values: "dietary_templates", "meal_style", "flavor_profile" */
  name: Scalars['String']['output'];
};

export type TagCategoryInput = {
  apiName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  /** Standard values: "dietary_templates", "meal_style", "flavor_profile" */
  name: Scalars['String']['input'];
};

export type TagCategoryV2 = {
  __typename?: 'TagCategoryV2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Any attribute that should be searchable. */
export type TagInput = {
  category: TagCategoryInput;
  displayName: Scalars['String']['input'];
  /** A string that should be used to display in the UI. */
  displayValue?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

/** Any attribute that should be searchable. */
export type TagV2 = {
  __typename?: 'TagV2';
  category: TagCategoryV2;
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type TagsInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['Int']['input'];
};

export type Variant = {
  id: Scalars['Int']['output'];
  macroNutrients: MacroNutrients;
  product: Product;
  tags: Array<Maybe<Tag>>;
};


export type VariantTagsArgs = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum VariantType {
  AddOnVariant = 'ADD_ON_VARIANT',
  MealVariant = 'MEAL_VARIANT'
}

export type VariantsInput = {
  gardenMealIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TagFieldsV2Fragment = { __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } };

export type CatalogsQueryVariables = Exact<{
  catalogsInput: CatalogsInput;
  itemsInput: CatalogItemsInput;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CatalogsQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'Catalog', id: number, eligibleDeliveryDates: Array<any>, items: Array<{ __typename?: 'CatalogItem', id: number, priceInCents: number, recommenderScore?: number | null, oneTimeOrderPriceInCents: number, soldOut: boolean, variant: { __typename: 'AddOnVariant', id: number, product: { __typename?: 'Product', id: number, imageUrl?: string | null, name: string, title: string, subtitle?: string | null, gardenMealId?: number | null, description?: string | null, designer: { __typename?: 'Designer', name: string } }, tags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, mealTypeTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, dietaryTemplateTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, flavorProfileTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, spicyTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, servingsTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, promotionalTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, celebrityChefTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, seasonalTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, territoryServesTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, newTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, improvedRecipeTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, statusTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null> } | { __typename: 'MealVariant', size: MealSize, containsAllergensCopy: string, nutritionCaveat?: string | null, publicIngredientsCopy: string, id: number, ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoid', displayName: string, isAllergen: boolean, legacyAllergenItemId: number, category: { __typename?: 'IngredientToAvoidCategory', legacyAllergenCategoryId: number, displayName: string } }>, macroNutrients: { __typename?: 'MacroNutrients', caloriesInG: number, calories: number, cholesterolInMg: number, dietaryFiberInG: number, netCarbsInG: number, proteinInG: number, saturatedFatInG: number, servingSizeInOz: number, sodiumInMg: number, sugarsInG: number, totalCarbsInG: number, totalFatInG: number, addedSugarInG?: number | null }, product: { __typename?: 'Product', id: number, imageUrl?: string | null, name: string, title: string, subtitle?: string | null, gardenMealId?: number | null, description?: string | null, designer: { __typename?: 'Designer', name: string } }, tags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, mealTypeTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, dietaryTemplateTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, flavorProfileTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, spicyTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, servingsTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, promotionalTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, celebrityChefTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, seasonalTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, territoryServesTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, newTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, improvedRecipeTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null>, statusTags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null> } } | null> }> };

export type TagFieldsFragment = { __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } };

export type TenantTagsQueryVariables = Exact<{
  tenantId: Scalars['Int']['input'];
}>;


export type TenantTagsQuery = { __typename?: 'Query', dietaryTemplateTags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypeTags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }> };

export type IngredientsToAvoidQueryVariables = Exact<{ [key: string]: never; }>;


export type IngredientsToAvoidQuery = { __typename?: 'Query', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoid', legacyAllergenItemId: number, displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategory', legacyAllergenCategoryId: number, displayName: string } }> };

export type VariantsQueryVariables = Exact<{
  variantsInput: VariantsInput;
}>;


export type VariantsQuery = { __typename?: 'Query', variants: Array<{ __typename?: 'AddOnVariant', id: number, product: { __typename?: 'Product', id: number, imageUrl?: string | null, name: string, title: string, subtitle?: string | null, description?: string | null, designer: { __typename?: 'Designer', name: string } }, tags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null> } | { __typename?: 'MealVariant', size: MealSize, containsAllergensCopy: string, nutritionCaveat?: string | null, publicIngredientsCopy: string, id: number, ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoid', displayName: string, isAllergen: boolean, legacyAllergenItemId: number, category: { __typename?: 'IngredientToAvoidCategory', legacyAllergenCategoryId: number, displayName: string } }>, macroNutrients: { __typename?: 'MacroNutrients', caloriesInG: number, calories: number, cholesterolInMg: number, dietaryFiberInG: number, netCarbsInG: number, proteinInG: number, saturatedFatInG: number, servingSizeInOz: number, sodiumInMg: number, sugarsInG: number, totalCarbsInG: number, totalFatInG: number, addedSugarInG?: number | null }, product: { __typename?: 'Product', id: number, imageUrl?: string | null, name: string, title: string, subtitle?: string | null, description?: string | null, designer: { __typename?: 'Designer', name: string } }, tags: Array<{ __typename?: 'Tag', id: number, displayValue?: string | null, displayName: string, value: string, category: { __typename?: 'TagCategory', apiName: string, id: number, name: string } } | null> }> };

export type ProgramFieldsFragment = { __typename?: 'Program', id: number, title: string, tenantId: number, description: string, durationInWeeks: number, totalPriceInCents: number, deliveryFeePerWeekInCents: number, crossedOutPriceInCents?: number | null, stripePriceId: string, extraConfig?: any | null, programMetros: Array<{ __typename?: 'ProgramMetro', metroId: number }> };

export type ProgramsQueryVariables = Exact<{
  input: ProgramsInput;
}>;


export type ProgramsQuery = { __typename?: 'Query', programs: Array<{ __typename?: 'Program', id: number, title: string, tenantId: number, description: string, durationInWeeks: number, totalPriceInCents: number, deliveryFeePerWeekInCents: number, crossedOutPriceInCents?: number | null, stripePriceId: string, extraConfig?: any | null, programMetros: Array<{ __typename?: 'ProgramMetro', metroId: number }> }> };

export type ValidateAddressForProgramQueryVariables = Exact<{
  programId: Scalars['Int']['input'];
  address: ProgramAddressInput;
}>;


export type ValidateAddressForProgramQuery = { __typename?: 'Query', validateAddressForProgram: { __typename?: 'Program', id: number, title: string, tenantId: number, description: string, durationInWeeks: number, totalPriceInCents: number, deliveryFeePerWeekInCents: number, crossedOutPriceInCents?: number | null, stripePriceId: string, extraConfig?: any | null, programMetros: Array<{ __typename?: 'ProgramMetro', metroId: number }> } };

export type ProgramCartBlueprintsQueryVariables = Exact<{
  input: ProgramsInput;
  deliveryWeek: Scalars['Date']['input'];
  metroId: Scalars['Int']['input'];
}>;


export type ProgramCartBlueprintsQuery = { __typename?: 'Query', programs: Array<{ __typename?: 'Program', programMetros: Array<{ __typename?: 'ProgramMetro', metroId: number, cartBlueprints: Array<{ __typename?: 'CartBlueprint', deliveryWeek: any, deliveries: Array<{ __typename?: 'CartDeliveryBlueprint', deliveryDate: any, lineItems: Array<{ __typename?: 'LineItemBlueprint', quantity: number, variant: { __typename?: 'AddOnVariant', product: { __typename?: 'Product', gardenMealId?: number | null, title: string, subtitle?: string | null, imageUrl?: string | null } } | { __typename?: 'MealVariant', product: { __typename?: 'Product', gardenMealId?: number | null, title: string, subtitle?: string | null, imageUrl?: string | null } } }> }> }> }> }> };
